export * from './lodash-wrapper';
import { isArray, flatten, isEmpty, forEach, find, union, isObject, isString } from './lodash-wrapper';

let _mediaQueryList = null;
export function isRetina() {
    if (!_mediaQueryList) {
        const mediaQuery = `(min--moz-device-pixel-ratio: 1.5),
        (-o-min-device-pixel-ratio: 3/2),
        (-webkit-min-device-pixel-ratio: 1.5),
        (min-device-pixel-ratio: 1.5),
        (min-resolution: 144dpi),
        (min-resolution: 1.5dppx)`;
        _mediaQueryList = window.matchMedia(mediaQuery);
    }
    return _mediaQueryList.matches;
}

export function hexToRgba(hexValue: any, alpha: number): string {
    const rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    const hex = hexValue.replace(rgx, (m: any, r: any, g: any, b: any) => r + r + g + g + b + b);
    const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const resultR = parseInt(rgb[1], 16);
    const resultG = parseInt(rgb[2], 16);
    const resultB = parseInt(rgb[3], 16);
    if (alpha) {
        return `rgba(${resultR},${resultG},${resultB},${alpha})`;
    } else {
        return `rgb(${resultR},${resultG},${resultB})`;
    }
}

interface FindTreeNodeMultiplePredicate {
    predicateKey: string;
    predicateValue: any;
    callbackParent?: (item: any) => void;
    callback?: (item: any) => void;
}

function getAll(value: Array<any> = [], array: Array<any>, childrenKey: string = 'children') {
    if (!find<any>(union(value), { id: 'parentNode' })) {
        value.push({
            id: 'parentNode',
            [childrenKey]: array
        });
    }
    forEach(array, item => {
        if (item[childrenKey]) {
            value = getAll(value, item[childrenKey], childrenKey);
        }
    });
    if (isEmpty(value)) {
        return array;
    } else if (isEmpty(array)) {
        return value;
    } else {
        return union(value, array);
    }
}

export function findTreeNode(
    tree: Array<any>,
    predicate: string | { [key: string]: any } | FindTreeNodeMultiplePredicate[],
    childrenKey?: string
): any;
export function findTreeNode<T>(
    tree: Array<T>,
    predicate: string | { [key: string]: any } | FindTreeNodeMultiplePredicate[],
    childrenKey?: string
): T {
    const allNode = flatten(getAll([], tree, childrenKey), true);
    if (isArray(predicate)) {
        (predicate as Array<FindTreeNodeMultiplePredicate>).forEach(n => {
            if (n.callback) {
                n.callback(find<T>(allNode, { [n.predicateKey]: n.predicateValue }));
            }
            if (n.callbackParent) {
                n.callbackParent(
                    find<T>(allNode, nn => {
                        if (find<T>(nn[childrenKey], { [n.predicateKey]: n.predicateValue })) {
                            return true;
                        }
                    })
                );
            }
        });
    } else if (isObject(predicate)) {
        return find<T>(allNode, predicate);
    } else if (isString(predicate)) {
        return find<T>(allNode, { _id: predicate });
    }
}

// TODO: Recursion Tree Node
export interface RecursionTreeNodeOption {
    predicateKey?: string;
    predicateValue?: any;
    predicateValues?: any;
    childrenKey?: string;
    callback?: (node: any) => void;
    callbackEvery?: (node: any) => void;
    callbackParent?: (node: any) => void;
    callbackParents?: (node: any) => void;
}
export function recursionTreeNode(node, op: RecursionTreeNodeOption = { childrenKey: 'children' }) {
    let isFind;
    if (op.callbackEvery) {
        op.callbackEvery(node);
    }
    const isTargetFind = _recursionTreeNodeIsMatchedPredicateValue(node[op.predicateKey], op.predicateValue, op.predicateValues);
    if (isTargetFind) {
        isFind = true;
        if (op.callback) {
            op.callback(node);
        }
    }
    if (node[op.childrenKey] && node[op.childrenKey].length > 0) {
        node[op.childrenKey].forEach(n => {
            if (this.recursionTreeNode(n, op)) {
                isFind = true;
            }
            const _isMatch = _recursionTreeNodeIsMatchedPredicateValue(n[op.predicateKey], op.predicateValue, op.predicateValues);
            if (_isMatch) {
                if (op.callbackParent) {
                    op.callbackParent(node);
                }
            }
        });
    }
    if (isFind && op.callbackParents && !isTargetFind) {
        op.callbackParents(node);
    }
    return isFind;
}

export function recursionFind<T>(tree: T, childrenKey: string, predicate: (leaf: T) => boolean, parent?: T): { current: T; parent: T } {
    if (predicate(tree)) {
        return { current: tree, parent: parent };
    }
    const length = tree[childrenKey] ? tree[childrenKey].length : 0;
    for (let i = 0; i < length; i++) {
        const currentTree = tree[childrenKey][i];
        const _res = this.recursionFind(currentTree, childrenKey, predicate, tree);
        if (_res) {
            return _res;
        }
    }
    return null;
}

function _recursionTreeNodeIsMatchedPredicateValue(value, matchValue, matchValues: any[]) {
    if (matchValue) {
        return value === matchValue;
    } else if (matchValues) {
        return matchValues.includes(value);
    }
}
